import React from 'react';
import { FormResponseWrapper } from 'organisms/requestCallForm/FormResponseStyles';

const QualifiedProResponse = (): JSX.Element => {
  return (
    // ID Necessary for GTM tracking
    <FormResponseWrapper id="qualifiedPro">
      <p><strong>Thank you!</strong></p>

      <a href="https://calendly.com/mighty-networks/mighty-pro-intro">Click here to schedule a call</a>
      <p>
        We’ll follow up shortly with some more details and background.
      </p>
      <p>Talk soon!</p>
    </FormResponseWrapper>
  );
};

export default QualifiedProResponse;
